import { useState, useEffect } from "react";
import { CustomInput } from "../Form/Input";
import {
  isCharLengthValid,
  isEmailFormat,
  isEmpty,
  IsSelectInputSelected
} from "src/utils/validator";
import CustomModal from "../Form/CustomModal";
import DataDomisiliJIRA from "../../data/DataDomisiliJIRA.json";
import { debounce } from "../../utils/helpers";
import iconDropdown from "../../../public/static/images/svg/Chevron.svg";
import {
  validatePhoneLength,
  validatePhoneNumber
} from "src/utils/form/FormInputValidate";
import { CheckBox } from "../Form/Checkbox";
import GC from "react-google-recaptcha";
import Router from "next/router";
import { encrypt } from "../../utils/cipher";
import fetch from "../../utils/fetch";
import { getTracker, DataTracker } from "../Tracker";

export const PromoLeads = ({ valueDump }) => {
  const [name, setName] = useState("");
  const [errorName, setErrorName] = useState("");
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [domicileValue, setDomicileValue] = useState("");
  const [listDomicile, setListDomicile] = useState([]);
  const [listDomicileName, setListDomicileName] = useState([]);
  const [modalDomicile, setModalDomicile] = useState(false);
  const [filteredDomicile, setFilteredDomicile] = useState([]);
  const [errorDomicile, setErrorDomicile] = useState(null);
  const [phone, setPhone] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [checkedLead, setCheckedLead] = useState(false);
  const [errorCheck, setErrorCheck] = useState("");
  const [valueCaptcha, setValueCaptcha] = useState(false);
  const [errorCapt, setErrorCapt] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formValidated, setFormValidated] = useState(true);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [btnSubmitPromoLeads, setBtnSubmitPromoLeads] = useState("Kirim Data");

  useEffect(() => {
    if (!formValidated) {
      setFormValidated(true);
    }
  }, [formValidated]);

  useEffect(() => {
    setListDomicile(DataDomisiliJIRA);

    name &&
    !errorName &&
    phone &&
    !errorPhone &&
    domicileValue &&
    !errorDomicile &&
    checkedLead &&
    valueCaptcha
      ? setIsBtnDisabled(false)
      : setIsBtnDisabled(true);
  }, [name, phone, email, domicileValue, checkedLead, valueCaptcha]);

  useEffect(() => {
    getlistDomicileName();
  }, [listDomicile]);

  const validateName = (val, errorSetter) => {
    let regex = /^[a-zA-Z ]+$/.test(val);
    setName(val);
    errorSetter("");
    if (isEmpty(val)) {
      errorSetter("Nama Wajib Diisi");
      return false;
    } else if (!isCharLengthValid(val, 3, 100)) {
      errorSetter("Nama Harus Terdiri Dari 3 - 100 Karakter");
      return false;
    } else if (!regex) {
      errorSetter("Harap tulis namamu dengan abjad, ya.");
    }
    return true;
  };

  const getDomicileValue = (e) => {
    const name = e.target.value;
    setDomicileValue(name);
    setErrorDomicile(null);
    setModalDomicile(false);
  };

  const showListDomicile = () => {
    setModalDomicile(true);
    // document.body.style.overflow = "hidden";
  };

  const validateEmail = (val, errorSetter) => {
    errorSetter("");
    if (isEmpty(val)) {
      errorSetter("Email Wajib Diisi");
      return false;
    } else if (!isEmailFormat(val)) {
      errorSetter("Format emailnya kayak gini, ya: alamat@email.com");
      return false;
    }
    return true;
  };

  const handleEmail = (e) => {
    validateEmail(e.target.value, setErrorEmail);
    setEmail(e.target.value);
  };

  const hideModal = (setterModal, setErrorMsg, value) => {
    document.body.style.overflow = "";
    setterModal(false);
    if (value == "") setErrorMsg("Domisili Wajib Diisi");
  };

  const getlistDomicileName = () => {
    const list = DataDomisiliJIRA.map((a) => a.name);
    setListDomicileName(list);
    setFilteredDomicile(list);
  };

  const handlePhone = (e) => {
    validatePhoneNumber(true, e.target.value, setErrorPhone, setPhone);
    setPhone(e.target.value);
  };

  const search = debounce((e, list, setFiltered) => {
    const x = e.target.value;
    const filteredSuggestions = list.filter(
      (suggestion) => suggestion.toLowerCase().indexOf(x.toLowerCase()) > -1
    );
    setFiltered(filteredSuggestions);
  });

  const handleCheck = (e) => {
    setCheckedLead(e.target.checked);
  };

  const handleValueCaptcha = (e) => {
    setValueCaptcha(e ? true : false);
  };

  const validateCity = (val, errorSetter) => {
    errorSetter("");
    if (!IsSelectInputSelected(val)) {
      errorSetter("Kota Wajib Dipilih");
      return false;
    }
    return true;
  };

  const validateCheckbox = (val, errorSetter) => {
    errorSetter("");

    if (!val) {
      errorSetter("Mohon isi bagian ini");
      return false;
    }
    return true;
  };

  const validateCaptcha = (val, errorSetter) => {
    errorSetter("");
    if (!val) {
      errorSetter("Mohon isi bagian ini");
      return false;
    }
    return true;
  };

  const validateForm = () => {
    if (
      !validateName(name, setErrorName) ||
      !validatePhoneNumber(true, phone, setErrorPhone, setPhone) ||
      !validateCity(domicileValue, setErrorDomicile) ||
      !validateEmail(email, setErrorEmail) ||
      !validateCheckbox(checkedLead, setErrorCheck) ||
      !validateCaptcha(valueCaptcha, setErrorCapt)
    ) {
      setFormValidated(false);
      return false;
    }
    return true;
  };

  const handleLeadsFormSubmit = async () => {
    if (isSubmitting || isBtnDisabled) {
      return;
    }

    if (!validateForm()) {
      //   scrollToError();

      return false;
    }
    await submitPromoLeadForm();
    await resetPromoLeadForm();
  };

  const submitPromoLeadForm = async () => {
    setBtnSubmitPromoLeads("Mengirim ...");
    setIsSubmitting(true);
    const postLeadsObject = {
      id_source: "PROMOLEADFORM",
      name: name,
      phone: phone,
      email: email,
      city: domicileValue,
      value_dump: valueDump,
      ...DataTracker(
        getTracker().utm_source,
        getTracker().utm_campaign,
        getTracker().utm_medium,
        getTracker().utm_content,
        getTracker().user_agent,
        getTracker().gclid,
        getTracker().guid
      )
    };

    const { status } = await fetch("POST", `/form/lead-form`, {
      data: encrypt(postLeadsObject)
    });

    await setIsSubmitting(false);
    if (status === 200) {
      await Router.push({
        pathname: "/thank-you",
        query: { form: "lead-form" }
      });
      resetPromoLeadForm();
    } else {
      setBtnSubmitPromoLeads("Gagal Mengirim");
      setTimeout(() => {
        setBtnSubmitPromoLeads("Coba Lagi");
      }, 3000);
    }
  };

  const resetPromoLeadForm = () => {
    setName("");
    setPhone("");
    setDomicileValue("");
    setEmail("");
    setValueCaptcha(false);
    setCheckedLead(false);
    setErrorName("");
    setErrorPhone("");
    setErrorDomicile("");
    setErrorEmail("");
    setErrorCheck("");
    setErrorCapt("");
  };

  return (
    <div className="leads-container">
      <div className="leads-header-wrapper">
        <div className="leads-header">Dapetin Promo Ini</div>
        <p>
          Tertarik? Yuk, isi data berikut dan kami akan segera menghubungimu!
        </p>
      </div>
      <div className="leads-input-wrapper">
        <div className="input-container">
          <CustomInput
            onChange={(e) => validateName(e.target.value, setErrorName)}
            value={name}
            label="Nama Sesuai KTP"
            locked={false}
            actived={false}
            name="name"
            type="text"
            pattern="[A-Za-z]"
            errMsg={errorName}
          />
        </div>
        <div className="input-container">
          <CustomInput
            onChange={(e) => handlePhone(e)}
            value={phone}
            label="Nomor HP"
            locked={false}
            actived={false}
            name="phone"
            type="number"
            pattern="[0-9]"
            maxLength={13}
            errMsg={errorPhone}
            onInput={(e) => validatePhoneLength(e)}
            additionalInfo="Nomor harus diawali dengan 08 atau 628, ya!"
          />
        </div>
        <div className="input-container">
          <CustomInput
            label="Kota Domisili"
            locked={false}
            actived={false}
            name="kota_domisili"
            icon={iconDropdown}
            value={domicileValue}
            onClick={showListDomicile}
            errMsg={errorDomicile}
            readOnly={true}
          />
        </div>
        {modalDomicile && (
          <CustomModal
            hideModal={() =>
              hideModal(setModalDomicile, setErrorDomicile, domicileValue)
            }
            listData={filteredDomicile}
            inputPlaceholder="Cari Kota Domisili"
            inputId="domisili"
            hideInputRadioIcon
            hideInputLocationIcon
            searchOnKeyUp={(e) =>
              search(e, listDomicileName, setFilteredDomicile)
            }
            getInputRadioValue={getDomicileValue}
            modalTitle="Kota Domisili"
          />
        )}
        <div className="input-container">
          <CustomInput
            onChange={(e) => handleEmail(e)}
            value={email}
            label="Alamat Email"
            locked={false}
            actived={false}
            name="email"
            type="text"
            pattern="[A-Za-z]"
            errMsg={errorEmail}
            additionalInfo="Format emailnya kayak gini, ya: alamat@email.com."
          />
        </div>
      </div>
      <div className="leads-consent-wrapper">
        <CheckBox
          onChange={handleCheck}
          title={`Saya dengan ini menyatakan telah memahami dan memberikan persetujuan kepada Home Credit dan/atau perwakilannya untuk menggunakan informasi dan/atau sarana komunikasi pribadi saya untuk tujuan yang berkaitan dengan penawaran dan/atau pemasaran dan/atau promosi produk Home Credit dan/atau Pihak Ketiga yang bekerja sama dengan Home Credit`}
          checked={checkedLead}
          errMsg={errorCheck}
          margin="0 0 16px"
          marginBottom="auto"
          paddingLeft="0px"
        ></CheckBox>
        <div className="kirim-button">
          <div className="captcha">
            <GC
              onChange={handleValueCaptcha}
              sitekey={process.env.captchaKey}
            ></GC>
            {errorCapt !== "" ? (
              <div className="error-captcha">{errorCapt}</div>
            ) : (
              ""
            )}
          </div>
          <div className="form-button">
            <button
              className={`button-submit ${
                isBtnDisabled ? " button-submit--disabled" : ""
              }`}
              onClick={handleLeadsFormSubmit}
              disabled={isBtnDisabled}
            >
              {btnSubmitPromoLeads}
            </button>
          </div>
        </div>
      </div>
      <style jsx>{`
        .leads-container {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          max-width: 98%;
          flex: 1;
          width: 100%;
          flex: 1;
          border-radius: 8.33px;
          background-color: var(--color-white);
          box-shadow: 0 3px 10px 0 var(--color-white-dark);
          align-self: auto;
          cursor: pointer;
          margin-left: 16px;
          margin-right: 16px;
          margin-top: 32px;
          margin-bottom: 48px;
        }

        .leads-header-wrapper {
          padding: 24px;
        }

        .leads-consent-wrapper {
          padding: 24px;
        }

        .leads-header {
          font-family: "Roboto";
          font-style: normal;
          font-weight: 700;
          font-size: 24px;
          line-height: 28px;
          text-align: left;
          letter-spacing: -0.24px;
          color: #404040;
        }

        .leads-input-wrapper {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          margin-left: 6%;
          flex-direction: column;
          height: 200px;
        }

        .kirim-button {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 40px;
        }

        .input-container {
          max-width: 420px;
          width: 100%;
          margin-left: -30px;
        }

        .form-button {
          margin-top: 20px;
        }

        .button-submit {
          height: 40px;
          width: 300px;
          background-color: #e11931;
          color: #ffffff;
          font-size: 15px;
          font-weight: bold;
          letter-spacing: 0.26px;
          line-height: 20px;
          justify-content: center;
          align-items: center;
          display: flex;
          border-radius: 4px;
          cursor: pointer;
        }
        .button-submit--disabled {
          background-color: #4f4f4f;
        }

        @media only screen and (max-width: 840px) {
          .leads-input-wrapper {
            height: auto;
            align-items: center;
          }
        }

        @media only screen and (max-width: 600px) {
          .leads-header {
            font-size: 15px;
          }
          .leads-header-wrapper p {
            font-size: 13px;
          }
          .input-container {
            width: 100%;
          }
          .leads-container {
            max-width: 400px;
            width: 100%;
          }
          .leads-consent-wrapper {
            padding: 16px;
          }
          .leads-input-wrapper {
            flex-direction: column;
            wrap: nowrap;
            margin-left: 0;
          }
          .input-container {
            margin: 0;
          }
        }
      `}</style>
    </div>
  );
};
